import { render, staticRenderFns } from "./TournamentOverviewContainer.vue?vue&type=template&id=39a66676&"
import script from "./TournamentOverviewContainer.vue?vue&type=script&lang=js&"
export * from "./TournamentOverviewContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports